import { Box, Grid, TextField } from '@mui/material';
import React from 'react';

import {PixelTagsType} from './PixelTypes';

function PixelTags(tags: PixelTagsType) {
    const {
        htmlGeneralTags,
        htmlLandingPageTags,
        htmlHomePageTags,
        htmlOtherTags,
        htmlTrackConversionTags
    } = tags;
    return (
        <Box>
            <Grid container mt={2}>
                <Grid item xs={8}>
                    <TextField
                        name='previewGeneralTags'
                        label='Base Script Tags'
                        value={htmlGeneralTags || ''}
                        fullWidth
                        multiline
                        rows={6}
                        disabled
                    />
                </Grid>
            </Grid>
        <Grid container mt={2}>
            <Grid item xs={8}>
                <TextField
                    name='previewLandingPageTags'
                    label='Landing Page Tags'
                    value={htmlLandingPageTags || ''}
                    fullWidth
                    multiline
                    rows={6}
                    disabled
                />
            </Grid>
        </Grid>
        <Grid container mt={2}>
            <Grid item xs={8}>
                <TextField
                    name='previewHomePageTags'
                    label='Home Page Tags'
                    value={htmlHomePageTags || ''}
                    fullWidth
                    multiline
                    rows={6}
                    disabled
                />
            </Grid>
        </Grid>
        <Grid container mt={2}>
            <Grid item xs={8}>
                <TextField
                    name='previewTags'
                    label='Other Tags'
                    value={htmlOtherTags || ''}
                    fullWidth
                    multiline
                    rows={6}
                    disabled
                />
            </Grid>
        </Grid>
        <Grid container mt={2}>
            <Grid item xs={8}>
                <TextField
                    name='previewTags'
                    label='Track Conversion Tags'
                    value={htmlTrackConversionTags || ''}
                    fullWidth
                    multiline
                    rows={6}
                    disabled
                />
            </Grid>
        </Grid>
    </Box>
    );
}

export default PixelTags;
